import React, {useEffect} from 'react';
import {useParams} from "react-router";
import {useQuery} from "@tanstack/react-query";
import Loader from "../../../components/template/loader.jsx";
import LoginService from "../../../services/web/login-service.js";
import {navigateHook} from "../../../hooks/use-navigate.js";

const Open = () => {
    const {uuid} = useParams();
    const navigate = navigateHook();

    const {data, isError} = useQuery({
        queryFn: () => LoginService.generateTokenHash(uuid),
        queryKey: ["token-hash", uuid],
        enabled: !!uuid
    });

    useEffect(() => {
        if (!data) return;

        const redirect = data.redirect?.trim();
        navigate(redirect || "/home");
    }, [data]);

    useEffect(() => {
        if (isError) navigate("/404");
    }, [isError]);

    return (
        <Loader />
    )
};

export default Open;